let xmanObj: any;

const openXman = (callback: () => any, error: () => any) => {
    (window as any).SCHD_COMS.use([ 'xman' ], () => {
        const SCXman = (window as any).SCHD_COMS.SCXman;
        if (!xmanObj) {
            xmanObj = new SCXman.Popup({
                members: 'both',
            });
            xmanObj.on('LOGIN_SUCCESS', () => {
                callback && callback();
            });
            xmanObj.on('AFTER_HIDE', () => {
                error && error();
                xmanObj.set('members', 'both');
                xmanObj.set('activeIndex', 0);
                xmanObj = null;
            });
        }
        xmanObj.show();
    });
};

export default openXman;
